{
  // Elements marked [data-mobile-first] move to the front of their parent on mobile and back to
  // their server-rendered spot on desktop. Real DOM moves (never CSS order/flex-reverse) so tab
  // order always matches the visual order.
  const els = [...document.querySelectorAll('[data-mobile-first]')]
  const desktopNext = new Map(els.map(el => [el, el.nextElementSibling]))

  const update = () => {
    const mobile = window.innerWidth <= 768
    els.forEach(el => {
      const parent = el.parentElement
      // only move when out of place -- moving re-fires custom element connectedCallbacks
      if (mobile) {
        if (parent.firstElementChild !== el) parent.prepend(el)
      } else if (el.nextElementSibling !== desktopNext.get(el)) {
        parent.insertBefore(el, desktopNext.get(el))
      }
    })
  }
  window.addEventListener('resize', update)
  update()
}
